// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e70s","left":"styles_left__Cjy-R","desktopActions":"styles_desktopActions__BC8iR","title":"styles_title__1z3YW"};